const postAdd = document.querySelector(".review_create_content .post_add");



const HttpApi = {
    reviewAPI: e => {
        e.preventDefault();
        var formData = new FormData(document.querySelector(".review_form")); // Currently empty

        var request = new XMLHttpRequest();
        request.open("POST", "/api/review", true);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                var res = this.response;
                var data = JSON.parse(res);
                if (data.msg === "후기가 등록되었습니다.") {
                    window.location.href = "/mypage";
                } else {
                    alert(data.msg);
                }
            } else {
                // We reached our target server, but it returned an error
            }
        };
        request.onerror = function() {
            // There was a connection error of some sort
        };
        request.send(formData);
    }
};
if (postAdd !== null) {
    postAdd.addEventListener("click", HttpApi.reviewAPI);
}

class REVEIWAPI {
    constructor(btn, modal, closeBtn, closeBack, name, date, content) {
        this.btn = btn;
        this.modal = modal;
        this.closeBtn = closeBtn;
        this.closeBack = closeBack;
        this.name = name;
        this.date = date;
        this.content = content;
    }
    openEvent(e) {
        var request = new XMLHttpRequest();
        const modal = this.modal;
        const name = this.name;
        const date = this.date;
        const content = this.content;
        request.open("GET", `/api/review/get/${e}`, true);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                var res = this.response;
                var data = JSON.parse(res);
                modal.style.display = "flex";
                name.textContent = data.now.user_email;
                const created_at = data.now.created_at.split(" ");
                date.textContent = created_at[0];
                content.textContent = data.now.content;
            } else {
                // We reached our target server, but it returned an error
            }
        };
        request.onerror = function() {
            // There was a connection error of some sort
        };
        request.send();
    }
    closeEvent() {
        this.modal.style.display = "none";
    }
    clickEvent() {
        for (let i = 0; i < this.btn.length; i++) {
            this.btn[i].addEventListener("click", e => {
                e.preventDefault();
                this.openEvent(this.btn[i].getAttribute("data-n"));
            });
        }
        this.closeBtn.addEventListener("click", () => this.closeEvent());
        this.closeBack.addEventListener("click", () => this.closeEvent());
        // this.btn.addEventListener("click", this.openEvent);
    }
}

const myReviewOpenBtn = document.querySelectorAll(".my_review_open");

if (myReviewOpenBtn.length > 0) {
    const setMyReview = new REVEIWAPI(
        myReviewOpenBtn,
        document.querySelector(".my_review_popup"),
        document.querySelector(".my_review_popup .close_btn"),
        document.querySelector(".my_review_popup .back"),
        document.querySelector(".my_review_popup .name"),
        document.querySelector(".my_review_popup .date"),
        document.querySelector(".my_review_popup .content")
    );

    setMyReview.clickEvent();
}


//const finishClose = document.querySelector(".finish-modal .btn-result");

//finishClose.addEventListener("click", () => {
//    
//    var finishModal = document.querySelector(".finish-modal");
//    finishModal.style.display = "none";
//});
